import React, { useState } from "react";
import { Button, TextField, Typography, Box, Paper } from "@mui/material";

const OHSSeriousForm = ({ onFormSubmit, incidentId }) => {
    const [fileNumber, setFileNumber] = useState("");
    const [loading, setLoading] = useState(false);
    const [additionalFormLoading, setAdditionalFormLoading] = useState(false);

    const handleSubmit = (formData) => {
        onFormSubmit(formData, incidentId);
    };

    const handleFormSubmit = (e) => {
        e.preventDefault();
        setLoading(true);
        const formData = { fileNumber };
        handleSubmit(formData);
        // Optionally reset form
        setFileNumber("");
        setLoading(false);
    };

    return (
        <Paper elevation={3} sx={{ p: 3, maxWidth: 400, margin: "auto" }}>
            <Box component="form" onSubmit={handleFormSubmit} noValidate>
                <Typography variant="h6" gutterBottom>
                    OHS Serious Incident Flag
                </Typography>
                <Typography variant="body2" color="textSecondary" gutterBottom>
                    Please visit the OHS website to provide full particulars of the incident.
                </Typography>
                <TextField
                    label="OHS File Number"
                    value={fileNumber}
                    onChange={(e) => setFileNumber(e.target.value)}
                    fullWidth
                    margin="normal"
                />
                <Button type="submit" variant="contained" color="primary" fullWidth disabled={loading}>
                    {loading ? "Submitting..." : "Flag as OHS Serious Incident"}
                </Button>
                <button 
                    type="submit" 
                    disabled={additionalFormLoading}
                    className={additionalFormLoading ? 'submit-button disabled' : 'submit-button'}
                >
                    {additionalFormLoading ? 'Submitting...' : 'Submit'}
                </button>
            </Box>
        </Paper>
    );
};

export default OHSSeriousForm;